  <template>
    <div v-if="mobile==false">
      <v-row class="ma-16">
        <p class="text-h3 text-primary"> Kontakt </p>
      </v-row>
      <v-row class="ma-16">
        <v-col cols="6" lg="4">
          <div class="text-center"><v-icon color="primary" icon="mdi-phone" size="x-large"></v-icon></div>
          <p class="text-h4 text-center"> Telefon </p>
          <p class="text-h4 font-weight-light text-center"> 605 909 880 </p>
        </v-col>
        <v-col cols="6" lg="4">
          <div class="text-center"><v-icon color="primary" icon="mdi-email" size="x-large"></v-icon></div>
          <p class="text-h4 text-center"> E-Mail </p>
          <p class="text-h4 font-weight-light text-center"> kontakt@alpakowyraj.pl </p>
        </v-col>
        <v-col cols="12" lg="4">
          <div class="text-center"><v-icon color="primary" icon="mdi-web" size="x-large"></v-icon></div>
          <p class="text-h4 text-center"> Facebook </p>
          <p class="text-center"> <a href="https://www.facebook.com/people/Alpakowy-Raj-Kołdry/61553534998486/" class="text-decoration-none text-black text-h4 font-weight-light"> fb.me/alpakowyrajkoldry </a> </p>
        </v-col>
      </v-row>
      <br />
      <v-row class="ma-16">
        <p class="text-h5 text-weight-light">Masz pytanie? Wypełnij formularz</p>
      </v-row>
    </div>

    <div v-if="mobile==true">
      <v-row class="ma-8">
        <v-col cols="12">
          <p class="text-h4 text-primary text-center"> Kontakt </p>
        </v-col>
      </v-row>
      <v-row class="ma-8">
        <v-col cols="12">
          <div class="text-center"><v-icon color="primary" icon="mdi-phone" size="x-large"></v-icon></div>
          <p class="text-h5 text-center"> Telefon </p>
          <p class="text-h5 font-weight-light text-center"> 605 909 880 </p>
        </v-col>
        <v-col cols="12">
          <div class="text-center"><v-icon color="primary" icon="mdi-email" size="x-large"></v-icon></div>
          <p class="text-h5 text-center"> E-Mail </p>
          <p class="text-h5 font-weight-light text-center"> kontakt@alpakowyraj.pl </p>
        </v-col>
        <v-col cols="12">
          <div class="text-center"><v-icon color="primary" icon="mdi-web" size="x-large"></v-icon></div>
          <p class="text-h5 text-center"> Facebook </p>
          <p class="text-center"> <a href="https://www.facebook.com/people/Alpakowy-Raj-Kołdry/61553534998486/" class="text-decoration-none text-black text-h5 font-weight-light"> fb.me/alpakowyrajkoldry </a> </p>
        </v-col>
      </v-row>
      <br />
      <v-row class="mt-8 mx-8">
        <p class="text-h5 text-weight-light text-center">Masz pytanie? Wypełnij formularz</p>
      </v-row>
    </div>

    <v-form ref="valid">
      <v-row class="ma-16 align-center">
        <v-col cols="0" md="1"></v-col>
        <v-col cols="12" md=5>
          <v-text-field
              v-model="name"
              label="Imię"
              variant="outlined"
            ></v-text-field>
            <v-text-field
              v-model="surname"
              label="Nazwisko"
              variant="outlined"
            ></v-text-field>
            <v-text-field
              v-model="email"
              :rules="emailRules"
              label="Adres E-Mail"
              required
              variant="outlined"
            ></v-text-field>
        </v-col>
        <v-col cols="12" md="5">
          <v-textarea 
            label="Treść wiadomości" 
            v-model="msg"
            variant="outlined"
            clearable
            no-resize
            rows="8" 
            counter="1000"
            :rules="msgRules">
          </v-textarea>
        </v-col>
        <v-col cols="0" md="1"></v-col>
    </v-row>
    <v-row justify="center" class="mb-2">
      <v-btn color="primary" @click="formValid()">Wyślij</v-btn>
    </v-row>
  </v-form>

  <v-snackbar
      v-model="msgSnackbar"
      color="secondary"
    >
      Wiadomość została przesłana
      <template v-slot:actions>
        <v-btn
          icon="mdi-close"
          color="red"
          @click="msgSnackbar = false"
        >            
        </v-btn>
      </template>
    </v-snackbar>
  </template>
  
  <script>
  import axios from 'axios'

  export default {
    title () {
      return 'Foo Page'
    },
    data: () => ({
      mobile: false,
      name: '',
      surname: '',
      email: '',
      msg: '',
      msgSnackbar: false,
      emailRules: [
        value => {
          if (value) return true

          return 'E-mail jest wymagany.'
        },
        value => {
          if (/.+@.+\..+/.test(value)) return true

          return 'Podany adres E-mail jest nieprawidłowy.'
        },
      ],
      msgRules: [
        value => {
          if (value) return true

          return 'Treść wiadomości nie może być pusta.'
        },
        value => {
          if (value?.length <= 1000) return true

          return 'Maksymalna dozwolona ilość znaków wynosi 1000.'
        },
      ],
    }),
    created() {
      this.mobile = this.$vuetify.display.mobile
    },
    methods: {
      async formValid() {
        const { valid } = await this.$refs.valid.validate()
        if(valid) {
          //Wysyłanie maila na kontakt@alpakowyraj.pl przez jakiś backend

          axios
          .post(`${process.env.VUE_APP_API}/mail-client`, {
            'to': 'pawelmilde@gmail.com', 
            'subject': '[Alpakowy Raj - Kołdry] Nowe Zapytanie', 
            'text': '<center><h4>Nowe zapytanie!<br /></h4>'+this.name+' '+this.surname+'<br />'+this.email+'<br /> <br /> Treść Pytania: <br /> <h4> '+this.msg+' </h4><br /><br /><i>--- Wiadomość generowana automatycznie ---</i> </center>', 
          }, {
              headers: { 'Content-Type': 'application/json' }
          });

          this.msgSnackbar = true;

          this.name = '';
          this.surname = '';
          this.msg = '';
          this.email = '';
        }
      },
    }

  }
  </script>
  